import { render, staticRenderFns } from "./ReminderTile.vue?vue&type=template&id=00a1c55d"
import script from "./ReminderTile.vue?vue&type=script&lang=js"
export * from "./ReminderTile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports